import React, { useEffect } from 'react';

export const useGridContentStyle = () => {
  const gridElement = document.querySelector('.grid-contents-view__content');
  const navContainerElement = document.querySelector('.nav__container');
  const filterByGenreElement = document.querySelector('.filter-container')
  useEffect(
    () => {
      if (gridElement?.children?.length <= 0 || !gridElement) return;
      const filterbygenreElementHeight = filterByGenreElement?.offsetHeight;
      const visibleContainerHeight =
        document.body.clientHeight - navContainerElement?.offsetHeight - filterbygenreElementHeight;


      if (
        gridElement?.scrollHeight > visibleContainerHeight &&
        document
          .querySelector('.footer_web--footer')
          .classList.contains('fixed-footer')
      ) {
        document
          .querySelector('.footer_web--footer')
          .classList.remove('fixed-footer');
      }
    },
    [gridElement?.children?.length],
  );

  useEffect(() => {
    window.addEventListener('resize', () => {
      const filterbygenreElementHeight = filterByGenreElement?.offsetHeight;
      const containerHeight =
        document.body.clientHeight - navContainerElement?.offsetHeight - filterbygenreElementHeight;
      const hasPositionFixedStyle = document
        .querySelector('.footer_web--footer')
        .classList.contains('fixed-footer');
      const gridElementHeight = document.querySelector(
        '.grid-contents-view__content',
      )?.scrollHeight;

      if (gridElementHeight > containerHeight && hasPositionFixedStyle) {
        document
          .querySelector('.footer_web--footer')
          .classList.remove('fixed-footer');
      } else if (
        gridElementHeight <= containerHeight &&
        !hasPositionFixedStyle
      ) {
        document
          .querySelector('.footer_web--footer')
          .classList.add('fixed-footer');
      }

      return ()=> window.removeEventListener('resize', ()=>{})
    });
  }, []);
};
